/**
 *
 * ClassForm
 *
 */
import { Class } from 'core/utils/types/modules/org';
import React, { memo } from 'react';
import styled from 'styled-components/macro';
import { Input } from 'core/components/Input';
import { RootState } from 'controller/types';
import { useDispatch, useSelector } from 'react-redux';
import { useBranchSetupSlice } from 'features/BranchSetup/slice';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { useParams } from 'react-router-dom';
import { SubmitButton } from 'core/components/SetupComponents/SubmitButton';
import { useFeePaymentDuration } from 'features/BranchSetup/hooks/useFetchFeePaymentDuration';
import { DropDown } from 'libs/DropDown';
import { isValidInput } from 'core/utils/constants';

interface Props {
  values?: Class | any;
  action?: string;
  onNext?: () => void;
}

export const ClassForm = memo((props: Props) => {
  const authData = useAuth();
  const dispatch = useDispatch();
  const { actions } = useBranchSetupSlice();
  const state = useSelector((state: RootState) => state.branchSetup);
  const params = useParams();
  const [feePaymentList, setFeePaymentList] = React.useState<[]>();
  const [selectedFeePayment, setselectedFeePayment] = React.useState(1);
  const [submitDisabled, setSubmitDisabled] = React.useState(true);
  const [isDirty, setIsDirty] = React.useState<boolean>(false);

  useFeePaymentDuration(feePaymentList, setFeePaymentList);

  const [values, setvalues] = React.useState<Class>({
    NAME: '',
    CLASS_CODE: '',
    MINDZIT_CLASS_CODE: '',
  } as Class);



  React.useEffect(() => {
    const isFormValid =
      isValidInput(values?.NAME) &&
      isValidInput(values.CLASS_CODE) &&
      isValidInput(values.MINDZIT_CLASS_CODE);

    setSubmitDisabled(!isFormValid);
  }, [values]);


  const handleInputChange = e => {
    const { name, value } = e.target;
    setvalues({
      ...values,
      [name]: value,
    });
    setIsDirty(true);
  };

  React.useEffect(() => {
    if (state?.navigate) {
      props?.onNext && props?.onNext();
      dispatch(actions.setNavigate(false));
    }
  }, [state?.navigate])


  const onSubmit = e => {
    e.preventDefault();
    dispatch(
      actions.createBranchSetupStart({
        URL: params?.url as string || 'class',
        data: {
          ...values,
          BRANCH_ID: authData?.BRANCH_ID as number,
          FEE_PAYMENT_DURATION_ID: selectedFeePayment,
        },
        action: props.action || 'save',
        message: props.action
          ? 'Updated Successfully!'
          : 'Created Successfully!',
      }),
    );
    setIsDirty(false);
  };



  React.useEffect(() => {
    if (props.values?.CLASS_ID) {
      setvalues({ ...props.values } as Class);
      setselectedFeePayment(props.values?.FEE_PAYMENT_DURATION_ID);
    }
  }, [props.values?.CLASS_ID]);

  return (
    <Div onSubmit={onSubmit}>
      <div className="grid grid-cols-2 gap-4 items-start">
        <Input
          name="NAME"
          placeholder="Class Name"
          onChange={handleInputChange}
          value={values.NAME}
          label="Name"
          required
          maxLength={100}
        />
        <Input
          name="CLASS_CODE"
          placeholder="Class Code"
          onChange={handleInputChange}
          value={values.CLASS_CODE}
          label="Class Code"
          required
          maxLength={45}
        />
        <Input
          name="MINDZIT_CLASS_CODE"
          placeholder="MindZit Class Code"
          onChange={handleInputChange}
          value={values.MINDZIT_CLASS_CODE}
          label="MindZit Class Code"
          required
          maxLength={45}
        />
        {!!feePaymentList?.length && (
          <DropDown
            defaultValue={feePaymentList?.find(
              (item: any) =>
                item?.FEE_PAYMENT_DURATION_ID === (selectedFeePayment || 1),
            )}
            getOptionValue={(option: any) => option.FEE_PAYMENT_DURATION_ID}
            getOptionLabel={(option: any) =>
              `${option.DURATION_NAME.toUpperCase()}`
            }
            options={feePaymentList as any[]}
            placeholder="Select Fee Payment Duration"
            label="Select Fee Payment Duration"
            onChange={(item: any) => {
              setselectedFeePayment(item?.FEE_PAYMENT_DURATION_ID);
              setIsDirty(true);
            }}
            name="FEE_PAYMENT_DURATION_ID"
          />
        )}
      </div>
      {/* <SubmitButton
        inputValidate={
          values &&
          ((values.NAME !== undefined && values.NAME.trim() === '' && !values.NAME.length) ||
            (values.CLASS_CODE !== undefined && values.CLASS_CODE.trim() === '' && !values.CLASS_CODE.length) ||
            (values.MINDZIT_CLASS_CODE !== undefined && values.MINDZIT_CLASS_CODE.trim() === '' &&
              !values.MINDZIT_CLASS_CODE.length))
        }
      /> */}
      {/* <Button type='primary' label='Submit' disabled /> */}
      <div className='text-center'>
        <SubmitButton inputValidate={submitDisabled} isDirty={isDirty} />
      </div>
    </Div>
  );
});

const Div = styled.form``;